// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_AT_RULE_IMPORT_0___ from "-!../../../node_modules/css-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[1]!../../../node_modules/postcss-loader/dist/cjs.js??ruleSet[1].rules[1].oneOf[5].use[2]!../../App.css";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.i(___CSS_LOADER_AT_RULE_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#landing {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: center;
  gap: 80px;
  position: relative;
  min-height: 100vh;
  background: var(--dark);
  width: 85%;
  padding-bottom: 100px;
  overflow: auto;
  overflow-x: hidden;
}

#landing header {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-top: 30px;
  font-family: var(--font-family);
}

#landing header h1 {
  font-size: 4em;
  background: linear-gradient(180deg, var(--green) 36.98%, var(--very-dark-green) 93.79%);
  background-clip: content-box;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  margin-bottom: 0;
}

#landing header h3 {
  font-size: 2.5em;
  color: var(--white-green);
  margin: 0;
}

#landing header strong {
  font-size: 2.2em;
  margin-top: 0;
  color: white;
}

#landing header p {
  text-align: center;
  width: 60%;
  margin: auto;
  color: rgb(197, 197, 197);
  font-size: 1.1em;
}

@media (max-width: 700px) {
  #landing {
    width: 100%;
    justify-content: center;
    gap: 40px;
    padding-bottom: 100px;
  }

  #landing header {
    margin-top: 20px;
  }

  #landing header h1 {
    font-size: 2.8em;
    width: 100%;
    text-align: center;
    background: linear-gradient(180deg, var(--green) 36.98%, var(--dark-green) 93.79%);
    background-clip: content-box;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
  }

  #landing header h3 {
    font-size: 2.2em;
    width: 100%;
    text-align: center;
  }

  #landing header strong {
    font-size: 1.1em;
    width: 100%;
    text-align: center;
  }

  #landing header p {
    text-align: center;
    width: 90%;
    font-size: 0.9em;
    line-height: 1.5;
  }
}
`, "",{"version":3,"sources":["webpack://./src/routes/Landing/Landing.css"],"names":[],"mappings":"AACA;EACE,aAAa;EACb,sBAAsB;EACtB,2BAA2B;EAC3B,mBAAmB;EACnB,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,uBAAuB;EACvB,UAAU;EACV,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,uFAAuF;EACvF,4BAA4B;EAC5B,6BAA6B;EAC7B,oCAAoC;EACpC,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,YAAY;EACZ,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE;IACE,WAAW;IACX,uBAAuB;IACvB,SAAS;IACT,qBAAqB;EACvB;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,kBAAkB;IAClB,kFAAkF;IAClF,4BAA4B;IAC5B,6BAA6B;IAC7B,oCAAoC;EACtC;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,gBAAgB;IAChB,WAAW;IACX,kBAAkB;EACpB;;EAEA;IACE,kBAAkB;IAClB,UAAU;IACV,gBAAgB;IAChB,gBAAgB;EAClB;AACF","sourcesContent":["@import url(\"/src/App.css\");\n#landing {\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: center;\n  gap: 80px;\n  position: relative;\n  min-height: 100vh;\n  background: var(--dark);\n  width: 85%;\n  padding-bottom: 100px;\n  overflow: auto;\n  overflow-x: hidden;\n}\n\n#landing header {\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  margin-top: 30px;\n  font-family: var(--font-family);\n}\n\n#landing header h1 {\n  font-size: 4em;\n  background: linear-gradient(180deg, var(--green) 36.98%, var(--very-dark-green) 93.79%);\n  background-clip: content-box;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  margin-bottom: 0;\n}\n\n#landing header h3 {\n  font-size: 2.5em;\n  color: var(--white-green);\n  margin: 0;\n}\n\n#landing header strong {\n  font-size: 2.2em;\n  margin-top: 0;\n  color: white;\n}\n\n#landing header p {\n  text-align: center;\n  width: 60%;\n  margin: auto;\n  color: rgb(197, 197, 197);\n  font-size: 1.1em;\n}\n\n@media (max-width: 700px) {\n  #landing {\n    width: 100%;\n    justify-content: center;\n    gap: 40px;\n    padding-bottom: 100px;\n  }\n\n  #landing header {\n    margin-top: 20px;\n  }\n\n  #landing header h1 {\n    font-size: 2.8em;\n    width: 100%;\n    text-align: center;\n    background: linear-gradient(180deg, var(--green) 36.98%, var(--dark-green) 93.79%);\n    background-clip: content-box;\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n  }\n\n  #landing header h3 {\n    font-size: 2.2em;\n    width: 100%;\n    text-align: center;\n  }\n\n  #landing header strong {\n    font-size: 1.1em;\n    width: 100%;\n    text-align: center;\n  }\n\n  #landing header p {\n    text-align: center;\n    width: 90%;\n    font-size: 0.9em;\n    line-height: 1.5;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
